// import localForage from 'localforage';
import VuexPersistence from 'vuex-persist';

// Key lưu giá trị trong IndexDB
export const KEY_DB_NAME = 'AMS';
export const KEY_STORE_NAME = 'Store';
export const KEY_APP = 'AMS-App';


/*Khởi tạo instance của VuexPersistance*/
const vuexPersistence = new VuexPersistence({
	key: KEY_APP,
	//storage: window.localStorage,
	storage: window.sessionStorage,
	asyncStorage: false
	// saveState: async (key, state, storage) => {
	// 	return Promise.resolve(storage.setItem(key, state));
	// },
	// restoreState: async (key, storage) => {
	// 	return Promise.resolve(storage.getItem(key));
	// }
});

// Trả về plugin của vuex persistance
export const createVuexPersistance = () => {
	return vuexPersistence.plugin;
};

// Xóa dữ liệu của store trong storage
export const removeStorage = () => {
	this.$ms.commonFn.removeLocalStorage(KEY_APP);
};
